import React, { Fragment } from 'react';
import { object, string, bool, func } from 'prop-types';
import * as R from 'ramda';
import { format } from 'date-fns';

import {
  TaskWrap,
  ButtonWrap,
  Title,
  TaskDueDate,
  JustText,
  UserAvatar,
  ListBox,
} from './styles';

import { ButtonWithLoader } from '../../../components/ui-helpers';
import { getAvatarUrl, isDateExpired } from '../../../utils';
import { ReactQuillWrapped } from '../../../components/react-quill';
import TaskPriority from '../../../components/task-item/task-priority';
import { TASK_PRIORITIES } from '../../../api/constants';

const DATE_FORMAT = 'd MMM yyyy';
const TIME_FORMAT = 'HH:mm';

export const TaskDetails = ({
  title,
  description,
  taskPriority,
  status,
  dueDate,
  dueTime,
  assignedTo,
  onClose,
}) => {
  const getTaskPriority = priority => R.find(({ value }) => value === priority, TASK_PRIORITIES);
  return (
    <Fragment>
      <TaskWrap>
        <div>
          <Title>Title:</Title>
          <JustText>{title}</JustText>
        </div>

        <ListBox style={{ alignItems: 'unset' }}>
          <Title>Description:</Title>
          <ReactQuillWrapped
            theme={null}
            readOnly
            width="100%"
            value={description}
            placeholder="There is no description to this task.."
          />
        </ListBox>
      </TaskWrap>

      <TaskWrap>
        <ListBox>
          <Title>Status:</Title>
          <JustText>
            {status ? 'Done' : 'In progress'}
          </JustText>
        </ListBox>

        <ListBox>
          <Title>Priority:</Title>
          <TaskPriority priority={getTaskPriority(taskPriority)} />
        </ListBox>

        <ListBox>
          <Title>Deadline:</Title>
          <TaskDueDate
            title="Due date"
            outOfDate={!status && isDateExpired(dueDate)}
          >
            {format(dueDate, DATE_FORMAT)}
            {dueTime && ` ${format(dueTime, TIME_FORMAT)}`}
          </TaskDueDate>
        </ListBox>

        <ListBox>
          <Title>Assignee:</Title>
          {
            !R.isEmpty(assignedTo) ?
              <Fragment>
                <UserAvatar
                  width={24}
                  height={24}
                  src={getAvatarUrl(assignedTo.profileImage)}
                />
                <JustText>
                  {assignedTo.fullName}
                </JustText>
              </Fragment>
              :
              <JustText>
                Unassigned...
              </JustText>
          }
        </ListBox>
      </TaskWrap>

      <ButtonWrap>
        <ButtonWithLoader onClick={onClose}>
        Close
        </ButtonWithLoader>
      </ButtonWrap>
    </Fragment>
  );
};

TaskDetails.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  taskPriority: string.isRequired,
  status: bool.isRequired,
  dueDate: string.isRequired,
  dueTime: string.isRequired,
  assignedTo: object,
  onClose: func.isRequired,
};

TaskDetails.defaultProps = {
  assignedTo: {},
};



// WEBPACK FOOTER //
// ./src/modals/tasks-modal/task-details/index.js